module.exports = __webpack_public_path__ + "img/spiral-calendar.dd401dc7.svg";